export interface ReloadPoint {
    id: string,
    label: string,
    selected: boolean
  }

export const reloadPoints: (ReloadPoint) [] = [
  { id: 'TRANSFORMATION', label: 'Transformation', selected: false },
  { id: 'FIDIL', label: 'FIDIL', selected: false },
  { id: 'KRP', label: 'KRP', selected: false },
  { id: 'POSTING', label: 'Posting', selected: false },
];

export default reloadPoints;
